<form [formGroup]="form" class="g-slider-container">
  <app-notification [type]="toasterType.Info">
    {{ editSensorTexts.info }}
  </app-notification>
  <div class="g-field-area">
    <label for="name">{{editSensorTexts.name}}</label>
    <input id="name"
           class="g-large-field"
           [placeholder]="editSensorTexts.name"
           formControlName="name"
    />
  </div>
  <ng-container *ngIf="showActiveNetworkElements">
    <div class="g-field-area">
      <span>{{editSensorTexts.active_query_networks}}</span>
        <label for="activeNetworks">{{ hasDuplicateNetwork ? editSensorTexts.help_tip_duplicate_network : editSensorTexts.help_tip }}</label>
      <textarea id="activeNetworks"
                [placeholder]="editSensorTexts.hint"
                formControlName="activeNetworks"
      ></textarea>
      <app-validation-message [messageText]="editSensorTexts.invalid_ip"
                              [validation]="formValidatorsService.isInvalidIp(activeNetworks)"
      ></app-validation-message>
    </div>
    <div class="g-field-area toggle-text-container">
      <app-toggle-form formControlName="active"></app-toggle-form>
      <span>{{editSensorTexts.sensor_active_queries}}</span>
    </div>
  </ng-container>
</form>
